var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.ModalTrigger,[_vm._t("open")],2),_c('Transition',[(_setup.isOpen)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _setup.closeModal.apply(null, arguments)}}},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }